import { IBenefit, transformBenefit } from './ContentfulBenefit'
import { IResource, transformResource } from './ContentfulResource'
import { IStatistic, transformStatistic } from './ContentfulStatistic'
import { ISolution as IContentfulSolution } from 'marketing-site/@types/generated/contentful'

export interface ISolution {
  name: string
  statistics: IStatistic[]
  benefits: IBenefit[]
  resources: IResource[]
}

export function transformSolution(props: IContentfulSolution): ISolution {
  const { name, statistics, benefits, resources } = props.fields
  return {
    name,
    statistics: statistics.fields.items.map((statistic) => transformStatistic(statistic)),
    benefits: benefits.fields.items.map((benefit) => transformBenefit(benefit)),
    resources: resources.fields.items.map((resource) => transformResource(resource)),
  }
}
